import { GridActionsCellItem } from "@mui/x-data-grid";
import { useQuery } from "@tanstack/react-query";
import { Delete, Edit, Eye } from "lucide-react";
import { useState } from "react";
import adminApi from "../../api/admin";
import DataTable from "../../components/common/DataTable";
import { formatDateForDisplay } from "../../utils/helpers";
import { Link, useNavigate } from "react-router-dom";
import useFetchTableData from "../../hooks/useFetchTableData";

const JobListingManagementPage = () => {
    const {data, error, isError, isLoading, paginationModel, setPaginationModel} = useFetchTableData({queryKey: "job-postings", fetchFunc: adminApi.getJobPostings})
    const navigate = useNavigate()

    const handleJobTitleClick = (job) => {
        navigate(`/admin/jobs/${job.id}`, {state: {job}})
    }
  

  const columns = [
    {
      field: "title",
      headerName: "Job Title",
      flex: 2,
      minWidth: 200,
      renderCell: (params) => <span onClick={() => handleJobTitleClick(params.row)} className="text-blue-600 hover:underline cursor-pointer">{params.value}</span>,
    },
    {
      field: "recruiter_name",
      headerName: "Recruiter",
      flex: 1,
      minWidth: 150,
      renderCell: (params) => params.value || "N/A",
    },
    {
      field: "location",
      headerName: "Location",
      flex: 1,
      minWidth: 120,
    },
    {
      field: "job_type",
      headerName: "Job Type",
      flex: 1,
      minWidth: 120,
      renderCell: (params) => (
        <span className="capitalize">
          {params.value?.replace("-", " ") || "N/A"}
        </span>
      ),
    },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      minWidth: 100,
      renderCell: (params) => {
        const status = params.value;
        const statusConfig = {
          active: { color: "bg-green-100 text-green-700", label: "Active" },
          draft: { color: "bg-yellow-100 text-yellow-700", label: "Draft" },
          closed: { color: "bg-red-100 text-red-700", label: "Closed" },
          expired: { color: "bg-gray-100 text-gray-700", label: "Expired" },
        };

        const config = statusConfig[status] || {
          color: "bg-gray-100 text-gray-700",
          label: status,
        };

        return (
          <span
            className={`px-2 py-1 rounded-full text-xs font-medium ${config.color}`}
          >
            {config.label}
          </span>
        );
      },
    },
    {
      field: "num_applicants",
      headerName: "Applicants",
      flex: 1,
      minWidth: 100,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "num_views",
      headerName: "Views",
      flex: 1,
      minWidth: 80,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "created_at",
      headerName: "Created",
      flex: 1,
      minWidth: 120,
      type: 'date',
      valueGetter: (params) => new Date(params),
      renderCell: (params) => {
        return formatDateForDisplay(params.row.created_at);
      },
    },
    // {
    //   field: "actions",
    //   type: "actions",
    //   headerName: "Actions",
    //   flex: 1,
    //   minWidth: 150,
    //   getActions: (params) => [
    //     <GridActionsCellItem
    //       icon={<Eye className="w-4 h-4" />}
    //       label="View"
    //       onClick={() => handleView(params.row)}
    //       showInMenu
    //     />,
    //     // <GridActionsCellItem
    //     //   icon={<Edit className="w-4 h-4" />}
    //     //   label="Edit"
    //     //   onClick={() => handleEdit(params.row)}
    //     //   showInMenu
    //     // />,
    //     // <GridActionsCellItem
    //     //   icon={<Delete className="w-4 h-4" />}
    //     //   label="Delete"
    //     //   onClick={() => handleDelete(params.row)}
    //     //   showInMenu
    //     //   sx={{ color: "error.main" }}
    //     // />,
    //   ],
    // },
  ];

  // Handler functions
  const handleView = (job) => {
    console.log("View job:", job);
    // Navigate to job details page
    onNavigate(`/admin/jobs/${job.id}`);
  };

  const handleEdit = (job) => {
    console.log("Edit job:", job);
    // Navigate to edit job page
    onNavigate(`/jobs/${job.id}/edit`);
  };

  const handleDelete = (job) => {
    console.log("Delete job:", job);
    // Implement delete confirmation and API call
    if (window.confirm(`Are you sure you want to delete "${job.title}"?`)) {
      // adminApi.deleteJobPosting(job.id).then(...)
    }
  };

  if (isError) {
    return (
      <div className="max-w-7xl mx-auto py-8 px-4">
        <div className="bg-red-50 border border-red-200 rounded-lg p-4">
          <p className="text-red-800">
            Error loading job postings: {error?.message}
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto">
      <div className="flex justify-between items-center mb-6">
        <div>
          <h1 className="text-3xl font-bold text-secondary-900">
            Job Listing Management
          </h1>
          <p className="text-secondary-600 mt-1">
            Total: {data?.count || 0} job postings
          </p>
        </div>
        {/* <Button 
          onClick={() => onNavigate('/post-job')} 
          icon={<Plus className="w-4 h-4 mr-2" />}
        >
          Post New Job
        </Button> */}
      </div>

      <DataTable
        rows={data?.results}
        columns={columns}
        loading={isLoading}
        rowCount={data?.count}
        paginationModel={paginationModel}
        onPaginationModelChange={setPaginationModel}
      />
    </div>
  );
};

export default JobListingManagementPage;
